<template>
    <div class="options-wrapper">
        <div class="form-sel-item">
            <div class="input-opt"><input :placeholder="title" :value="titleValue" type="text" @change="titleChange" /></div>
        </div>
        <div class="form-sel-item" v-for="(item, index) in options" :key="index">
            <div class="input-opt"><input :placeholder="optionLabel + (index + 1) + contentLabel" type="text" v-model="item.label" /></div>
            <i class="i-del" @click="deleteItem(index)"></i>
        </div>
        <div class="form-sel-item sel-item-add">
            <div class="sel-radio">
                <div :class="{ on: isSelected }" @click="radioSelect"></div>
                {{ isNeedOption }}
            </div>
            <div class="btn-item-add" @click="addItem"><i class="ico-ten"></i></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Options",
    props: ["data"],
    data() {
        return {
            options: [
                {
                    label: ""
                }
            ]
        };
    },
    computed: {
        optionLabel() {
            return this.$t("zhiji.form.option");
        },
        contentLabel() {
            return this.$t("zhiji.form.content");
        },
        title() {
            return this.$t("zhiji.form.options.input.title");
        },
        isNeedOption() {
            return this.$t("zhiji.form.isNeedOption");
        },
        titleValue() {
            return this.data.title;
        },
        isSelected() {
            return this.data.isNeed || false;
        },
        curOptions() {
            return this.data.options || [];
        }
    },
    watch: {
        curOptions: {
            handler(newValue) {
                let initOptions = [
                    {
                        label: ""
                    }
                ];
                let options = newValue.length > 0 ? newValue : initOptions;
                this.options = options;
            },
            immediate: true,
            deep: true
        },
        options: {
            handler(newValue) {
                this.commitStore({
                    options: newValue
                });
            },
            deep: true
        }
    },
    methods: {
        addItem() {
            if (this.options.length > 9) {
                return;
            }

            this.options.push({
                label: ""
            });
        },
        deleteItem(index) {
            this.options.splice(index, 1);
        },
        radioSelect() {
            this.commitStore({
                isNeed: !this.isSelected
            });
        },
        titleChange(event) {
            this.commitStore({
                title: event.target.value
            });
        },
        commitStore(widget) {
            widget.uId = this.data.uId;
            this.$store.commit("zhiji/editFormContents", {
                type: "updateFormContent",
                widget: widget
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.options-wrapper {
    font-size: 12px;
    padding: 8px 0 8px 8px;
    width: 594px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    background: #fafbfd;
    flex-grow: 0;
    flex-shrink: 0;

    .form-sel-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 8px;

        .input-opt {
            width: 539px;

            input {
                border-radius: 4px;
                padding: 9px 8px 10px 8px;
                background: #fff;
                width: 100%;
                border: solid 1px #d8e4f0;
                box-sizing: border-box;
            }
        }

        .i-del {
            margin-left: 8px;
            width: 18px;
            height: 18px;
            display: none;
            cursor: pointer;
            background: url($zhijiStaticImagePath+"class-spr.png");
            background-position: -95px 0;

            &:hover {
                background-position: -95px -22px;
            }
        }

        &:hover {
            .i-del {
                display: block;
            }
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .sel-item-add {
        justify-content: space-between;
        align-items: center;
        width: 539px;

        .sel-radio {
            & > div {
                display: inline-block;
                margin-right: 8px;
                width: 18px;
                height: 18px;
                background: url($zhijiStaticImagePath+"class-spr.png");
                background-position: -275px 0;
                vertical-align: text-bottom;
                cursor: pointer;
            }

            .on {
                background-position: -275px -20px;
            }
        }

        .btn-item-add {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 76px;
            height: 32px;
            background: #ffffff;
            border: 1px solid #d8e4f0;
            border-radius: 20px;
            cursor: pointer;

            .ico-ten {
                display: inline-block;
                width: 14px;
                height: 14px;
                vertical-align: middle;
                background: url($zhijiStaticImagePath+"class-spr.png");
                background-position: -297px -1px;
            }

            &:hover .ico-ten {
                background-position: -223px -100px;
            }
        }
    }
}
</style>
